import { format, formatDistance, parseISO } from 'date-fns';
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  try {
    return format(parseISO(dateString), 'MMM dd, yyyy');
  } catch {
    return dateString;
  }
};

export const formatDateTime = (dateString) => {
  if (!dateString) return 'N/A';
  try {
    return format(parseISO(dateString), 'MMM dd, yyyy HH:mm');
  } catch {
    return dateString;
  }
};

export const formatTime = (dateString) => {
  if (!dateString) return 'N/A';
  try {
    return format(parseISO(dateString), 'HH:mm');
  } catch {
    return dateString;
  }
};

export const formatRelativeTime = (dateString) => {
  if (!dateString) return 'N/A';
  try {
    return formatDistance(parseISO(dateString), new Date(), { addSuffix: true });
  } catch {
    return dateString;
  }
};

export const formatPhoneNumber = (phone) => {
  if (!phone) return 'N/A';
  return phone.replace(/^\+/, '');
};

export const getStatusColor = (status) => {
  const colors = {
    PENDING: 'bg-yellow-100 text-yellow-800',
    COMPLETED: 'bg-green-100 text-green-800',
    ALERTED: 'bg-red-100 text-red-800',
  };
  return colors[status] || 'bg-stone-100 text-stone-800';
};

export const getSlotLabel = (slot) => {
  const labels = {
    post_school_pickup: 'Post-school Pickup',
    lunch_activity: 'Lunch & Activity',
    evening_wrap: 'Evening Wrap-up',
  };
  return labels[slot] || slot;
};
